// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1116) return "static/chunks/1116-a09d690cb009d8fe.js";
	if (chunkId === 8743) return "static/chunks/8743-52b505ced23273bc.js";
	if (chunkId === 4316) return "static/chunks/ad2866b8-524fcfc71699f892.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 501 ? "bc98253f" : chunkId) + "." + {"501":"d72417b80aaa29c3","2030":"5c1063d4bd43b699","2931":"5a7e3f80e7128490","3386":"de667156524cb026","4199":"b40ff79c003cda18","5519":"a935ff6e2090fc32","5656":"9db1849920cb9261","5749":"1259e4429244db81","6377":"7a6eba57e9da6c05"}[chunkId] + ".js";
};